import React, { Component } from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkTranslation, getObject, translate } from "../utils/useful";
import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";
import SidebarView from '../components/SidebarView';
import ButtonAnimated from "../components/buttons/ButtonAnimated";
import { nanoid } from "nanoid";
import TableViewer from "../components/TableViewer";
import Header from "../components/header/Header";
import CollectionView from "../windows/Applets/database/CollectionView";
import RecordToolbar from "../components/header/RecordToolbar";
import ActionsBtn from "../components/partials/ActionsBtn";

class RecordContentViewer extends Component {


    showModal = () => {
        this.open()
    }

    hideModal = () => {
        // console.log('this.formdata', this.form.getForm())
        // console.log('this.props.initData', this.props.initData)
        // let currentItem = JSON.parse(JSON.stringify(this.form.getForm()))
        // this.props.setData('currentItem', currentItem, 'CollectionView', () => {

        // if (this.props.setData) {
        //     this.props.setData('relevantEdit', false, 'CollectionView')
        // }

        this.props.functionsHandler(null, 'closeOverlayFrame', { id: 'recordViewer' })
        // })
        this.onClose()
        if (this.form) {
            this.form.clearForm()
        }
        setTimeout(() => {
            this.setState({ showModal: false })
        }, 500);
    }

    state = {
        countries: [],
        actions: {
            cancel: { key: "cancel", label: "{{lang}}cancel", color: '#777', bgColor: '#e1e1e1', function: this.hideModal },
            submit: { key: "submit", label: "{{lang}}submit", bgColor: this.props.colors?.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', iconInvert: this.props.colors?.iconInvert, color: this.props.colors?.textColor ?? '#fff', function: () => this.submitForm(), loader: "isPostingData" },

        },
        default: { _id: 'details', name: '{{lang}}Details' },
        currentTab: 'details',
        headerConfig: {
            backAction: () => this.hideModal(),
            'title': "View Record",
            // 'subtitle': this.props.page?.subtitle,

        }
    }




    componentDidMount() {
        // console.log(checkTranslation(this.props.frame?.name))
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': this.toolbarView,
                toolbarPadding: 0,
                'showToolbar': true,
                'title': `${checkTranslation(this.props.frame?.name)} | ${translate("View record")}`,
                'subtitle': translate("View record"),
            })

        }

    }

    componentDidUpdate(prevProps) { }



    actionClicked = (prop, extra) => {

        let data = this.props.initData
        let index = null

        if (typeof prop.function == 'function') {
            prop.function(data, index)
        } else {
            if (this.props[prop.function]) {
                this.props[prop.function](data, index, prop)
            } else {
                let myExtra = extra

                if (typeof extra == 'object') {
                    myExtra = extra ? { ...extra } : {}
                    myExtra.index = index
                }

                this.props.functionsHandler('frame', prop.function, data, myExtra)
            }
        }

    }



    toolbarView = () => {

        let frameActions = this.props.frameActions ? JSON.parse(JSON.stringify(this.props.frameActions)) : null
        if (frameActions) {
            delete frameActions.edit
        }
        return (

            <div ref={el => this.stickyBar = el} className="flexcb  w-100 py-1" style={{ zIndex: 2, padding: '2px 0px', borderBottom: '0px solid #eee', backgroundColor: '#fff' }}>
                <div className="flexc w-80  px-3">
                    {/* <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.colors.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                        {this.props?.initData?._id ? (
                            <img className="invert" src="/assets/icons/useful/edit.png" height={14} alt="" />
                        ) : (
                            <img className="invert" src="/assets/icons/useful/edit.png" height={14} alt="" />
                        )}
                    </div> */}

                    {!this.props?.initData?._id && (

                        <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.colors.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>

                            <img className="invert" src="/assets/icons/useful/edit.png" height={14} alt="" />

                        </div>
                    )}

                    <p className="text-bold font-size-15 px-1">{(this.props.title ?? translate(this.props?.initData?._id ? "Edit Record" : "New Record"))}</p>

                    {(frameActions && this.props?.initData?._id) && (
                        <div>
                            <ActionsBtn showText={true} permissions={this.props.permissions} page={this.props.page} applet={this.props.applet} data={this.props.initData} actions={frameActions} actionClicked={this.actionClicked} currentRecord={this.props.initData} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} functionsHandler={this.props.functionsHandler} onOpen={this.onActionOpen} onClose={this.onActionClose} />
                        </div>
                    )}
                </div>


                <div className="flexce w-100 px-2 scroll-no-scrollbar">
                    {Object.values(this.state.actions).map((prop, index) => {
                        if (prop.key == 'submit' && this.state.hasNext) {
                            return (
                                <>
                                    {this.backButton()}
                                    <div className=" mld-2" key={index}  >
                                        <div className='flexc'>
                                            <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={this.formNextPage}
                                                title={translate('Next')}
                                                icon='/assets/icons/angle-right-white2.svg'
                                                textColor={prop.color ?? '#000'}
                                                bg={prop.bgColor}
                                                invert={prop.iconInvert}
                                                isLoading={this.state[prop.loader]}
                                            />
                                        </div>
                                    </div>
                                </>
                            )
                        } else {
                            return (
                                <>
                                    {prop.key == 'submit' && (
                                        this.backButton()
                                    )}
                                    <div className=" mld-2" key={index} >
                                        <div className='flexc'>
                                            {prop.key == 'submit' ? (
                                                <>
                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={prop.function}
                                                        title={checkTranslation(prop.label)}
                                                        icon='/assets/icons/angle-right-white2.svg'
                                                        textColor={prop.color ?? '#000'}
                                                        bg={prop.bgColor}
                                                        invert={prop.iconInvert}
                                                        isLoading={this.state[prop.loader]}
                                                    />
                                                </>
                                            ) : (
                                                <ButtonAnimated
                                                    iconwidth='24px'
                                                    onClick={prop.function}
                                                    title={checkTranslation(prop.label)}
                                                    textColor={prop.color ?? '#000'}
                                                    bg={prop.bgColor}
                                                    isLoading={this.state[prop.loader]}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    })}
                </div>
            </div>
            // <RecordToolbar setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} permissions={this.props.permissions} isMobile={this.props.isMobile} showStack={this.state.showStack} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.headers} view={this.state.currentView} />
        )
    }

    toolbarFunctionsHandler = (type, name, data) => {
        if (this[name]) {
            this[name](data)
        }
    }



    _handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation()
            this.hideModal()
        }
    }




    submitForm = () => {
        // console.log("SUB!")
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.setState({ isPostingData: true }, () => {
                    if (this.props.setHeader) {
                        this.props.setHeader("dummy", 1)
                    }
                })

                this.props.submitForm(data, null, (newData, err) => {

                    this.setState({ isPostingData: false }, () => {
                        if (this.props.setHeader) {
                            this.props.setHeader("dummy", 1)
                        }
                    })
                    if (err) {
                        return
                    }

                    // if (this.props.setData) {

                    //     this.props.setData('relevantEdit', false, 'CollectionView', () => {
                    //     })
                    // }
                    this.props.functionsHandler(null, 'closeOverlayFrame', { id: 'recordViewer' })


                })
            }
        } else {
            this.postValue()
        }
    }

    formNextPage = () => {
        this.form.nextPage()
        // console.log("Next")
        if (this.props.setHeader) {
            setTimeout(() => {
                this.props.setHeader("dummy", 1)
            }, 50);
        }
    }

    formBackPage = () => {
        this.form.backPage()
        setTimeout(() => {
            this.props.setHeader("dummy", 1)
        }, 50);
    }

    open = () => {
        // this.relevantModal.open()
        this.setState({ showModal: true })
        document.addEventListener("keydown", this._handleKeyDown);

    }

    close = () => {
        this.hideModal()
        document.removeEventListener("keydown", this._handleKeyDown);
    }


    onClose = () => {
        // setTimeout(() => {
        //     if (this.props.setData) {
        //         this.props.setData('currentRelevantTab', 'details', 'CollectionView', () => {
        //             this.setState({ showModal: false, currentTab: 'details' })
        //         })
        //     } else {

        //         this.setState({ showModal: false, currentTab: null }, () => {
        //             this.setState({ currentTab: 'details' })
        //         })
        //     }
        // }, 10);
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    postValue = () => {
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.key
                this.setState({ isPostingData: true })
                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }
                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })

                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info)
                    }
                    if (isEditing && this.props.itemEdited) {
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id)
                        } else {
                            this.props.itemEdited(data, data._id)
                        }
                    }
                })
            }
        }
    }

    setFormStatus = (key, value) => {
        this.setState({ [key]: value })
    }

    scrollToTop = () => {
        this.container.scrollTo(0, 0)
    }

    backButton() {
        if (this.state.hasBack) {
            return (
                <div className=" mld-2"  >
                    <div className="" >

                        <ButtonAnimated
                            onClick={this.formBackPage}
                            title={translate('Back')}
                            textColor={'#777'}
                            bg={'#eee'}
                        />

                    </div>
                </div>
            )
        }
    }

    // changeTab = (collection) => {
    //     if (this.state.currentTab != collection._id) {
    //         this.props.setData('currentRelevantTab', collection._id, 'CollectionView', () => {
    //             this.setState({ currentTab: collection._id }, () => {
    //                 if (collection._id != 'details') {
    //                     this.props.setData('isLoadingData', true, 'CollectionView', () => { })
    //                 }
    //                 let search = window.location.search
    //                 let id = new URLSearchParams(search).get('relevant')
    //                 let path = [...this.props.windowData.path]
    //                 let relevantRecords = []
    //                 if (collection._id != 'details') {
    //                     this.props.headers.map((element) => {
    //                         if (element.type == 'LookupInput') {
    //                             let value = getObject(this.props.initData, element.key)
    //                             if (Array.isArray(value)) {
    //                                 relevantRecords = value
    //                             }
    //                             else if (value) {
    //                                 relevantRecords.push(value)
    //                             }
    //                         }
    //                     })
    //                     this.props.fetchRelevantData(relevantRecords)
    //                     let variables = this.props.variables
    //                     variables.currentItem = collection
    //                     this.setState({ variables })
    //                     if (id) {
    //                         path[path.length - 1] = (path[path.length - 1].split('?relevant')[0] + `?relevant=${collection._id}`)
    //                     }
    //                     else {
    //                         path[path.length - 1] = path[path.length - 1] + `?relevant=${collection._id}`
    //                     }
    //                 }
    //                 else {
    //                     if (id) {
    //                         path[path.length - 1] = path[path.length - 1].split('?relevant')[0]
    //                     }
    //                 }
    //                 path.splice(0, 2)
    //                 this.props.changeWindowLink(path)
    //             })
    //         })
    //     }
    // }



    render() {

        let frame = this.props.frame ?? this.state.frame

        return (
            <div className="h-100 window-content-radius-bottom scroll-no-scrollbar" style={{ backgroundColor: 'rgb(229, 229, 234)' }} >


                <div className="flexc flex-column w-100  px-2 py-3">
                    <div className="px-2 py-2 br-10 w-100" ref={el => this.container = el} style={{ maxWidth: 800, }}>
                        {/* <div className="flexcb px-2 py-2" style={{ position: 'sticky', top: '52px', zIndex: 1, borderBottom: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                                <div className="flexc w-80  py-2 px-3">
                                    <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                                        <p>+</p>
                                    </div>
                                    <p className="text-bold text-normal px-1">{(this.props.title ?? translate(this.props?.initData?._id ? "useful.Edit" : "New Record"))}</p>
                                </div>
                                
                            </div> */}

                        <div className="w-100 mt-2 px-2 pt-2 h-100" style={{ paddingBottom: '10px' }}>
                            <FormViewer ref={el => this.form = el} headers={frame?.fields} pages={frame?.formPages} initData={this.props.initData} data={this.props.initData} width={this.props.width} errors={this.state.errors} inputClass={'bordered-input'} formClass={'bordered-form'} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} params={this.props.params} />
                        </div>



                        {/* <div className="flexc w-100 px-3 pb-5">
                            {Object.values(this.state.actions).map((prop, index) => {
                                if (prop.key == 'submit' && this.state.hasNext) {
                                    return (
                                        <>
                                            {this.backButton()}
                                            <div className=" mld-2" key={index}  >
                                                <div className='flexc'>
                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={this.formNextPage}
                                                        title={translate('Next')}
                                                        icon='/assets/icons/angle-right-white2.svg'
                                                        textColor={prop.color ?? '#000'}
                                                        bg={prop.bgColor}
                                                        isLoading={this.state[prop.loader]}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )
                                } else {
                                    return (
                                        <>
                                            {prop.key == 'submit' && (
                                                this.backButton()
                                            )}
                                            <div className=" mld-2" key={index} >
                                                <div className='flexc'>
                                                    {prop.key == 'submit' ? (
                                                        <ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={prop.function}
                                                            title={checkTranslation(prop.label)}
                                                            icon='/assets/icons/angle-right-white2.svg'
                                                            textColor={prop.color ?? '#000'}
                                                            bg={prop.bgColor}
                                                            isLoading={this.state[prop.loader]}
                                                        />
                                                    ) : (
                                                        <ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={prop.function}
                                                            title={checkTranslation(prop.label)}
                                                            textColor={prop.color ?? '#000'}
                                                            bg={prop.bgColor}
                                                            isLoading={this.state[prop.loader]}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            })}
                        </div> */}

                    </div>
                </div>

            </div>
        )

    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(RecordContentViewer);